import { toast } from 'react-toastify';
import { TableSessionEvent } from './types';
import { getDispatch } from '../../../store/dispatchAccessor';
import { api } from '../../../store/commonApi';
import { EOrderItemStatus, eOrderItemStatusFromJSON } from '../../../proto/order/orderItemStatus.enum';

export type OrderItemUpdatedType = TableSessionEvent & {
	type: 'ORDER_UPDATED';
	orderId: string;
	status: string;
};

export function handleOrderItemUpdatedEvent(e: OrderItemUpdatedType): void {
	const dispatch = getDispatch();

	dispatch(api.util.invalidateTags([{ type: 'Order', id: 'LIST' }]));

	const statusEnumValue = eOrderItemStatusFromJSON(parseInt(e.status));

	switch (statusEnumValue) {
		case EOrderItemStatus.PREPARING:
			toast.info('המוצר בהכנה');
			break;
		case EOrderItemStatus.COMPLETED:
			toast.success('המוצר מוכן לאיסוף');
			break;
		case EOrderItemStatus.PENDING:
			toast.warning('המוצר שונה לממתין');
			break;
		case EOrderItemStatus.CANCELLED:
			toast.error('המוצר בוטל');
			break;
		default:
			break;
	}
}
